import React from 'react';

import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';

function SectionHero() {
  return (
    <OldPageSectionHeading
      intlKey="OPEN_DATA.HEAD.TITLE"
      textAlign="center"
    />
  );
}

export default SectionHero;
